import { CreateTask, UpdateTask } from '../models/task';
import apiClient from './api';

export const getTask = async (taskID: number) => {
  const response = await apiClient.get(`/task/${taskID}`);
  return response.data;
}

export const getTasks = async (getCompletedTasks: boolean, pageSize?: number, pageIndex?: number, taskTypeID?: number) => {
  let params = new URLSearchParams();
  params.append('getCompletedTasks', getCompletedTasks.toString());
  if (pageSize) {
    params.append('pageSize', pageSize.toString());
  }
  if (pageIndex) {
    params.append('pageIndex', pageIndex.toString());
  }
  if(taskTypeID) {
    params.append('taskTypeID', taskTypeID.toString());
  }

  const response = await apiClient.get('/task', { params });
  return response.data;
}

export const getUserTenderingAccessTasks = async (userID: number) => {
  const response = await apiClient.get(`/task/user/${userID}`);
  return response.data;
}

export const createAccountRequest = async (task: CreateTask) => {
  const response = await apiClient.post('/task/account/request', task);
  return response.data;
}

export const createChangeRequestTask = async (task: CreateTask) => {
  const response = await apiClient.post('/task/document/changeRequest', task);
  return response.data;
}

export const createTenderingRequestTask = async (task: CreateTask) => {
  const response = await apiClient.post('/task/tendering/access', task);
  return response.data;
}

export const createTenderManagerTask = async (task: CreateTask) => {
  const response = await apiClient.post('/task/tenderManager', task);
  return response.data;
}

export const updateTask = async (id: number, task: UpdateTask) => {
  const response = await apiClient.put(`/task/${id}`, task, {responseType: 'text'});
  return response.data;
}

export const markTaskNotificationRead = async (taskID: number) => {
  const response = await apiClient.put(`/task/${taskID}/markNotificationRead`, null, {responseType: 'text'});
  return response.data;
}
